import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { MetricRanking, MetricRankingDetailed } from 'src/app/services/metric-rankings.service';
import { Observable, Subscription, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { MetricsService, Metric } from 'src/app/services/metrics.service';

@Component({
  selector: '[app-weighting-row]',
  templateUrl: './weighting-row.component.html',
  styleUrls: ['./weighting-row.component.scss']
})
export class WeightingRowComponent implements OnInit {


  @Input() metricRanking: MetricRanking;
  @Input() submitMetricRankingsEvent: Observable<boolean>;

  @Output() outputEvent = new EventEmitter<MetricRanking>();
  @Output() metricEvent = new EventEmitter<MetricRanking>();

  @Output() metricWeightChange = new EventEmitter();

  // nameEditMode: boolean;
  metricRankingData: MetricRankingDetailed;

  metricRankingsEventSubscription: Subscription;

  unsubscribe: Subject<any> = new Subject();

  constructor(
    private modalConfig: NgbModalConfig,
    private modalService: NgbModal,
    private metricsService: MetricsService
  ) {
    modalConfig.backdrop = 'static';
  }

  ngOnInit() {

    this.metricRankingData = {} as MetricRankingDetailed;

    if (this.metricRanking) {
      this.metricRankingData = this.metricRanking;
    }

    if (this.submitMetricRankingsEvent) {
      this.metricRankingsEventSubscription = this.submitMetricRankingsEvent
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(() => {
        this.outputEvent.emit(this.metricRankingData);
      });
    }
    setTimeout(this.ManageToggle, 500);
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  addMetric() {
    if (!this.metricRankingData || typeof this.metricRankingData.metricName === 'undefined') { 
      alert('New metric should have a name.');
      return; 
    }
    this.metricEvent.emit(this.metricRankingData);
    this.metricRankingData.metricName = "";
    this.metricRankingData.metricDescription = "";
  }

  ManageToggle() {
    var allInputs: any = document.getElementsByName('metric-enabled');
    var toogleCheck: any = document.getElementById('metric-toggle');
    var checkedTrue: number = 0;
    var checkedFalse: number = 0;
    var checkedOn: boolean = false;
    var checkedIndeterminate: boolean = true;

    allInputs.forEach(function (input) {
      if (input.checked === true) {
        checkedTrue = checkedTrue + 1;
      } else {
        checkedFalse = checkedFalse + 1;
      }
    });
    if ((checkedTrue == (checkedTrue + checkedFalse))) {
      checkedOn = true;
      checkedIndeterminate = false;
    } else if ((checkedFalse == (checkedTrue + checkedFalse))) {
      checkedOn = false;
      checkedIndeterminate = false;
    } 
      toogleCheck.checked = checkedOn;
      toogleCheck.indeterminate = checkedIndeterminate;
  }

  open(content) {
    this.modalService.open(content);
  }

  deleteMetric() {
    this.metricsService.deleteMetric(this.metricRanking.metricId, this.metricRanking.rankingId);
  }

  ngOnChanges(changes: SimpleChanges) {
    //console.log('SimpleChanges');
    //console.log(changes);
    this.metricWeightChange.emit();
  }

}
